import type { clientDataType } from '@/services/pre-enrollment/types';
import type { ValuesType } from './types';
import createFile from '@/utils/file-upload-function/createFile';

const nationalityInitialValue = (candidateData: clientDataType | undefined) => {
  if (candidateData) {
    if (candidateData?.nationality === 'brasileira') {
      return 'brasileira';
    }
    return 'outra';
  }
  return '';
};

const studentFinanceChecked = (
  candidateData: clientDataType | undefined,
  paymentMethod: string,
) => {
  if (paymentMethod === 'msc') {
    if (candidateData) {
      if (candidateData.student_financing_check) {
        return true;
      }
    }
    return false;
  }

  return null;
};

const pepChecked = (candidateData: clientDataType | undefined) => {
  if (candidateData) {
    if (candidateData.politically_exposed_person) {
      return 'true';
    }
    return 'false';
  }
  return '';
};

const initialFormValues = (
  candidateData: clientDataType | undefined,
  paymentMethod: string,
): ValuesType => {
  return {
    name: candidateData?.name || '',
    marital_status: candidateData?.marital_status || '',
    birthdate: candidateData?.birthdate || '',
    day: candidateData?.birthdate?.split('-')[2] || '',
    month: candidateData?.birthdate?.split('-')[1] || '',
    year: candidateData?.birthdate?.split('-')[0] || '',
    nationality: nationalityInitialValue(candidateData),
    nationalityOther:
      candidateData?.nationality && candidateData?.nationality !== 'brasileira'
        ? candidateData?.nationality
        : '',
    birthplace: candidateData?.birthplace || '',
    zipcode: candidateData?.zipcode || '',
    state: candidateData?.state || '',
    city: candidateData?.city || '',
    neighborhood: candidateData?.neighborhood || '',
    address: candidateData?.address || '',
    residence_type: candidateData?.residence_type || '',
    address_complement: candidateData?.address_complement || '',
    residence_number: candidateData?.residence_number || '',
    cpf: candidateData?.cpf || '',
    rg: candidateData?.rg || '',
    rg_issuing_body: candidateData?.rg_issuing_body || '',
    rg_issuing_state: candidateData?.rg_issuing_state || '',
    monthlyIncome: candidateData?.monthly_income || '',
    isMsc: `${paymentMethod === 'msc'}`,
    studentFinance: studentFinanceChecked(candidateData, paymentMethod),
    pep: pepChecked(candidateData),
    proofOfAddress: candidateData?.proof_of_residency_document_url
      ? createFile(
          candidateData?.proof_of_residency_document_url.split('_client_')[1],
        )
      : undefined,
    cpfFile: candidateData?.cpf_document_url
      ? createFile(candidateData?.cpf_document_url.split('_client_')[1])
      : undefined,
    rgFile: candidateData?.rg_document_url
      ? createFile(candidateData?.rg_document_url.split('_client_')[1])
      : undefined,
    selfieWithDocument: candidateData?.document_selfie_url
      ? createFile(candidateData?.document_selfie_url.split('_client_')[1])
      : undefined,
  };
};

export default initialFormValues;
